import {VirtualTeamsConstant as constants} from '../../../_constants/VirtualTeams/VirtualTeams.constants';

const initialState = { team_filter_loading : true, team_filter_data: {}, team_filter_error: false };

export function virtualTeamFilter(state = initialState, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_TEAM_FILTER_LOADING:
            return {
                team_filter_loading: true,
                team_filter_data: {},
                team_filter_error: false
            };
        case constants.VIRTUAL_TEAM_FILTER_DATA:
            return {
                team_filter_loading: false,
                team_filter_data: action,
                team_filter_error: false
            };
        case constants.VIRTUAL_TEAM_FILTER_ERROR:
            return {
                team_filter_loading: false,
                team_filter_data: {},
                team_filter_error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/VirtualTeams/VirtualTeamFilter/VirtualTeamFilter.reducer.js